import axios from "axios";

const API_URL = "https://e-take.botsband-dev.com/api";
const BITTRIX_URL = `https://etake.bitrix24.com/rest/1085/whh6mabvb1a3ky2j/tasks.task.add.Json`;

export const auth = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/auth`, {
      phone: String(payload.phone),
      telegram_id: String(payload.telegram_id),
      ref_phone: payload.ref_phone || "",
    });
    // Відповідь має структуру { found: "true", data: {...} }
    return response.data.data;
  } catch (err) {
    console.error(err);
  }
};

export const postBonusChange = async (payload) => {
  try {
    const body = {
      id: String(payload.id),
      qty: String(payload.qty),
      type: payload.type,
      reason: payload.reason,
      ...(payload.sku && { sku: payload.sku }),
    };
    const response = await axios.post(`${API_URL}/bonus-change`, body);
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const getBonusProduct = async () => {
  try {
    const response = await axios.get(`${API_URL}/gifts`);
    // Відповідь має структуру { ok: "true", data: [...] }
    return response.data.data;
  } catch (err) {
    console.error(err);
  }
};

export const postToBittrix = async (payload) => {
  try {
    const response = await axios.post(BITTRIX_URL, payload);
    return response.data;
  } catch (err) {
    console.error(err);
  }
};
